export default {
  meta: {
    label: 'German (Deutsch)'
  },
  data: {
    de: {
      97: [['🍎', 'Apfel'], ['👽', 'Alien'], ['👁️', 'Auge'], ['🦅', 'Adler']],
      98: [['🍌', 'Banane'], ['👶', 'Baby'], '🐝', ['🍐', 'Birne'],['📫', 'Briefkasten'],['🥖', 'Brot']],
      99: [['🤡', 'Clown']],
      100: [['🐬', 'Delfin']],
      101: [['🥚', 'Ei'], ['🦎', 'Eidechse'], ['🦄','Einhorn']],
      102: [['🐸', 'Frosch'],  ['👣', 'Füße'], ['🛫', 'Flugzeug']],
      103: [['👻','Geist'], ['🦍', 'Gorilla'], ['🎻', 'Geige'], ['🚶', 'Gehen'],['🥠', 'Glückskeks']],
      104: [['🥅', 'Hockey-Netz'], ['🏒', 'Hockeyschläger'], ['🐹', 'Hamster'], '🌺', ['🐇', 'Hase']],
      105: ['🐙'],
      106: [['🤹🏼‍♀️', 'Jongleur'], '👖', ['🕹️', 'joystick']],
      107: [['🚑', 'Krankenwagen'],['☕️', 'Kaffee'],['🧀', 'Käse'],['🥝', 'Kiwi'], ['🍰', 'Kuchen'], ['🐰', 'Kaninchen'], ['🥕', 'Karotte']],
      108: [['🦁', 'Löwe'], ['🐆', 'Löwe']],
      109: [['🌝', 'Mond'], '🍈', ['👄', 'Mund'], ['🎶', 'Musiknoten']],
      110: [['👃', 'Nase']],
      111: [['🐙', 'Oktopus'], ['👌', 'Ok']],
      112: [['🥞', 'Pfannenkuchen'], ['🍟', 'Pommes'], ['🌶', 'Pfeffer'], ['🚔', 'Polizei']],
      113: ['🇶🇦'],
      114: [['🤖', 'Roboter'], ['♻️', 'Recyceln'], ['☂️', 'Regenschirm'], ['🍷', 'Rotwein']],
      115: [['🐍', 'Schlange'], '🤳', '🥗', ['⭐️', 'Stern'], ['🍫', 'Schokolade'], ['☀️', 'Sonne']],
      116: [['🦃', 'Truthahn'], ['🐯', 'Tiger'], ['🌮', 'Taco'], ['🐅', 'Tiger']],
      117: [['🚇', 'U-Bahn']],
      118: [['🏐', 'Volleyball'], ['🌋', 'Vulkan']],
      119: [['🌊', 'Welle'], ['🍉', 'Wassermelone'], ['🐳', 'Wal']],
      120: [],
      121: [['💴', 'Yen'], ['☯️', 'Yin'], ['☯️', 'Yang']],
      122: [['⚡️', 'zappen']]
    }
  }
};
